module.exports = __webpack_public_path__ + "img/ce.7ac71d20.png";